import React from 'react'

const Loader = () => {
  return (
    <>
        <div className="loader"></div>
    <p style={{textAlign:'center', color:'red'}}>Pas de réponse !</p>
    </>

  )
}

export default Loader